import * as ss from 'superstruct';
import { ConnectedAccountResource } from '../connected-accounts';
import { AdAccountPlatform } from './ad-account-platform';

/**
 * An ad platform account owned by an Arrows Up account. Each ad account
 * belongs to exactly one Arrows Up account, across all of them.
 *
 * `externalId` is stored in the form the platform's API uses (see
 * `AdAccountIdRules`); `name`, `currencyCode` and `timeZone` come from the
 * platform when the ad account is verified. `apiKey` is for platforms
 * `AdAccountTypes` adds by API key.
 */
export const AdAccountResource = ss.assign(
  ConnectedAccountResource,
  ss.type({
    platform: AdAccountPlatform,
    externalId: ss.string(),
    currencyCode: ss.optional(ss.nullable(ss.string())),
    /** IANA time zone the platform reports days in. */
    timeZone: ss.optional(ss.nullable(ss.string())),
  }),
);

export type AdAccountResource = ss.Infer<typeof AdAccountResource>;

/** An ad account our platform credentials can reach. */
export const DiscoveredAdAccount = ss.type({
  platform: AdAccountPlatform,
  externalId: ss.string(),
  name: ss.optional(ss.string()),
  currencyCode: ss.optional(ss.string()),
  timeZone: ss.optional(ss.string()),
  /** Already registered to this Arrows Up account. */
  registeredHere: ss.boolean(),
  /** Already registered to a different Arrows Up account. */
  registeredElsewhere: ss.boolean(),
});

export type DiscoveredAdAccount = ss.Infer<typeof DiscoveredAdAccount>;
